const formatOtherPhoneNumbers = (otherPhoneNumbers) => {
  let str = "";
  let otherNumbers = [];
  let phoneNumber = "";
  for(let tenant_no of otherPhoneNumbers){
    if(!(tenant_no.firstName.length == 0 && tenant_no.phoneNumber.length == 0)){
      phoneNumber = tenant_no.phoneNumberFormatted || tenant_no.phoneNumber;
      otherNumbers.push(`{ firstName: "${tenant_no.firstName}", phoneNumber: "${phoneNumber}"}`);
    }

  }
  if (otherNumbers.length > 0){
    str = otherNumbers.join(",")
  }
  return str;
}

const formatDeposits = (deposits) => {
  let str = "";
  let deposits_str = [];
  let amountReturned = "0"
  for(let deposit of deposits){
    if(deposit.name.length > 0 && parseFloat(deposit.amountPaid) >= 0){
      amountReturned = deposit.amountReturned || amountReturned;
      deposits_str.push(`{ name: "${deposit.name}", amountPaid: ${deposit.amountPaid}, amountReturned: ${amountReturned} }`);
    }
  }
  if(deposits_str.length > 0){
    str = deposits_str.join(",")
  }
  return str;
}

const formatNextOfKin = (nextOfKin) => {
  let str = "";
  let nextOfKinArray = [];
  for (let i of (nextOfKin || [])) {
    if (!i) continue;
    const phoneNumber = i.phoneNumberFormatted || i.phoneNumber || "";
    const relationship = i.relationship || "";
    const information = i.information || "";
    if (i.name || phoneNumber || relationship || information) {
      nextOfKinArray.push(`{ name: "${i.name || ""}", phoneNumber: "${phoneNumber}", relationship: "${relationship}", information: "${information}" }`);
    }
  }
  if (nextOfKinArray.length > 0) {
    str = nextOfKinArray.join(",");
  }
  return str;
}

//Mutation to add new tenant to a unit in a property
export const AddTenantMutation = (payload) => {
    const {
      email = "",
      firstName = "",
      lastName = "",
      phoneNumber = "",
      unitId = "",
      moveInDate = "",
      moveOutDate = "",
      notes = "",
      accountId = "",
      deposits = [],
      nextOfKin = [],
      otherPhoneNumbers = [],
      nationalIdNumber = "",
      taxPin = "",
      penaltyType = "",
      fixedPenaltyAmount = 0,
      percentagePenaltyAmount = 0,
      automaticallyPenalize = false,
      penaltyDayOfMonth = 0,
      leaseStartDate = "",
      leaseEndDate = "",
      bankPayerNames = []
    } = payload || {};
    const mutation = `
    mutation($file: Upload){
        addTenant(
          email:"${email}",
          firstName:"${firstName}",
          lastName:"${lastName}",
          deposits: [${formatDeposits(deposits)}],
          phoneNo:"${phoneNumber}",
          unit:${JSON.stringify(unitId)},
          moveInDate: ${moveInDate===null ? JSON.stringify("") : JSON.stringify(moveInDate)},
          moveOutDate: ${moveOutDate===null ? JSON.stringify("") : JSON.stringify(moveOutDate)},
          penaltyType: "${penaltyType}",
          fixedPenaltyAmount: ${fixedPenaltyAmount},
          percentagePenaltyAmount: ${percentagePenaltyAmount},
          automaticallyPenalize: ${automaticallyPenalize},
          penaltyDayOfMonth: ${penaltyDayOfMonth},
          notes: ${JSON.stringify(notes)},
          accountId: "${accountId}",
          taxPin: "${taxPin}",
          nationalIdNumber: "${nationalIdNumber}",
          nextOfKin: [${formatNextOfKin(nextOfKin)}],
          otherPhoneNumbers: [${formatOtherPhoneNumbers(otherPhoneNumbers)}],
          leaseStartDate: ${leaseStartDate===null ? JSON.stringify("") : JSON.stringify(leaseStartDate)},
          leaseEndDate: ${leaseEndDate===null ? JSON.stringify("") : JSON.stringify(leaseEndDate)},
          bankPayerNames: ${JSON.stringify(bankPayerNames)},
          fileUpload: $file
        ){
          tenant{
            propertyId
            depositJson
            unitName
            unitId
            rentAmount
            tenantId
            firstName
            lastName
            phoneNumber
            email
            accountBalance
            moveInDate
            moveOutDate
            notes,
            leaseStartDate,
            leaseEndDate,
            penaltyType,
            fixedPenaltyAmount,
            percentagePenaltyAmount,
            automaticallyPenalize,
            penaltyDayOfMonth,
            taxPin
            accountId
            archived
            bankPayerNames
            nationalIdNumber
            otherPhoneNumbers{
              firstName
              phoneNumber
            }
            nextOfKin
            upload{
              id
              file
            }
          }
          errorMessage
        }
      }
    `;
    return mutation;
}

//Query to get a list of units and tenants and their details
export const GetUnitsTenantsMutation = (propertyID) => {
    const query = `
    query{
      allUnitsTenantsData(property:${JSON.stringify(propertyID)}){
        propertyName,
        unitName,
        tenantId
        rentAmount,
        firstName,
        lastName,
        phoneNumber,
        email,
        accountBalance,
        archived,
        accountId,
        taxPin,
        bankPayerNames,
        nationalIdNumber,
        otherPhoneNumbers{
          firstName
          phoneNumber
        },
        nextOfKin,
        upload{
          id
          file
        }
      }
    }
    `
    return query
  }

//Query to get a tenants and their details
export const GetTenantDataQuery = (tenantId) => {
  const query = `
  query{
    getTenant(tenantId:${JSON.stringify(tenantId)}){
      propertyId
        unitName
        unitId
        rentAmount
        tenantId
        firstName
        lastName
        phoneNumber
        email
        accountBalance
        depositJson
        moveInDate
        moveOutDate
        notes
        leaseStartDate
        leaseEndDate
        penaltyType,
        fixedPenaltyAmount,
        percentagePenaltyAmount,
        automaticallyPenalize,
        penaltyDayOfMonth,
        accountId
        archived
        taxPin
        bankPayerNames
        nationalIdNumber
        nextOfKin
        otherPhoneNumbers{
          firstName
          phoneNumber
        }
        nextOfKin
        upload{
          id
          file
        }
    }
  }`
  return query
}

export const GetTenantInUnitMutation = (unitId) => {
  const query = `
  query{
    unitTenant(unitId: ${JSON.stringify(unitId)}){
      id
      archived
      unit{
        id
        property{
          id
          waterRate
          electricityRate
        }
      }
      user{
        firstName
        lastName
      }
    }
  }
  `
  return query
}

export const UpdateTenantMutation = (payload) => {
    const {
      tenantId,
      email = "",
      firstName = "",
      lastName = "",
      phoneNumber = "",
      unitId = "",
      moveInDate = "",
      moveOutDate = "",
      notes = "",
      archived = false,
      accountId = "",
      deposits = [],
      updateFile = false,
      nextOfKin = [],
      otherPhoneNumbers = [],
      nationalIdNumber = "",
      taxPin = "",
      penaltyType,
      fixedPenaltyAmount,
      percentagePenaltyAmount,
      automaticallyPenalize,
      penaltyDayOfMonth,
      leaseStartDate = "",
      leaseEndDate = "",
      bankPayerNames = []
    } = payload || {};
    let optionalArgs = "";
    if (penaltyDayOfMonth){
      optionalArgs += `penaltyDayOfMonth: ${penaltyDayOfMonth}, `;
    }
    if (penaltyType){
      optionalArgs += `penaltyType: "${penaltyType}", `;
    }
    if (fixedPenaltyAmount != null){
      optionalArgs += `fixedPenaltyAmount: ${fixedPenaltyAmount}, `;
    }
    if (percentagePenaltyAmount != null){
      optionalArgs += `percentagePenaltyAmount: ${percentagePenaltyAmount}, `;
    }
    if (automaticallyPenalize != null){
      optionalArgs += `automaticallyPenalize: ${automaticallyPenalize} `;
    }

  const mutation = `
    mutation($file: Upload){
      updateTenant(
          email:"${email}",
          firstName:"${firstName}",
          lastName:"${lastName}",
          deposits: [${formatDeposits(deposits)}],
          phoneNo:"${phoneNumber}",
          unit:${JSON.stringify(unitId)},
          id:${JSON.stringify(tenantId)},
          moveInDate: ${moveInDate===null ? JSON.stringify("") : JSON.stringify(moveInDate)},
          moveOutDate: ${moveOutDate===null ? JSON.stringify("") : JSON.stringify(moveOutDate)},
          notes: ${JSON.stringify(notes)},
          archived: ${archived},
          accountId: "${accountId}",
          nationalIdNumber: "${nationalIdNumber}",
          taxPin: "${taxPin}",
          updateFile: ${updateFile},
          nextOfKin: [${formatNextOfKin(nextOfKin)}],
          otherPhoneNumbers: [${formatOtherPhoneNumbers(otherPhoneNumbers)}],
          leaseStartDate: ${leaseStartDate===null ? JSON.stringify("") : JSON.stringify(leaseStartDate)},
          leaseEndDate: ${leaseEndDate===null ? JSON.stringify("") : JSON.stringify(leaseEndDate)},
          bankPayerNames: ${JSON.stringify(bankPayerNames)},
          fileUpload: $file,
          ${optionalArgs}
      ){
          tenant{
            propertyId
            depositJson
            unitName
            unitId
            rentAmount
            tenantId
            firstName
            lastName
            phoneNumber
            email
            accountBalance
            moveInDate
            moveOutDate
            notes
            leaseStartDate,
            leaseEndDate,
            accountId
            archived
            nationalIdNumber
            taxPin
            bankPayerNames
            otherPhoneNumbers{
              firstName
              phoneNumber
            }
            nextOfKin
            upload{
              id
              file
            }
          }
          errorMessage
        }
      }
    `;
  return mutation;
}

  //Delete tenant mutation
  export const DeleteTenantMutation = (id) => {
    const mutation = `
    mutation{
      deleteTenant(id:${JSON.stringify(id)}){
        success
      }
    }
    `
    return mutation
  }

// Get all tenant data using a list of property IDs
//propertyIDs is a list of property IDs
  export const GetAllTenantsDataQuery = (propertyIDs) => {
    const query = `
    query{
      allTenantDataUsingList(propertyIds:${JSON.stringify(propertyIDs)}){
        propertyId
        unitName
        unitId
        rentAmount
        tenantId
        firstName
        lastName
        phoneNumber
        email
        accountBalance
        depositJson
        moveInDate
        moveOutDate
        notes
        leaseStartDate
        leaseEndDate
        penaltyType,
        fixedPenaltyAmount,
        percentagePenaltyAmount,
        automaticallyPenalize,
        penaltyDayOfMonth,
        accountId
        archived
        taxPin
        bankPayerNames
        nationalIdNumber
        nextOfKin
        otherPhoneNumbers{
          firstName
          phoneNumber
        }
        upload{
          id
          file
        }
      }
    }
    `
    return query;
  }

export const queryPropertyTenants = (propertyIDs, searchText="") => {
  const query = `
    query{
      propertySpecificTenants(
        propertyIds:${JSON.stringify(propertyIDs)}, searchText: "${searchText}"){
          propertyId
          depositJson
          unitName
          unitId
          rentAmount
          tenantId
          firstName
          lastName
          phoneNumber
          email
          accountBalance
          moveInDate
          moveOutDate
          notes
          leaseStartDate
          leaseEndDate
          penaltyType,
          fixedPenaltyAmount,
          percentagePenaltyAmount,
          automaticallyPenalize,
          penaltyDayOfMonth,
          accountId
          taxPin
          bankPayerNames
          nationalIdNumber
          archived
          nextOfKin
          otherPhoneNumbers{
            firstName
            phoneNumber
          }
      }
  }`;
  return query;
}

export const getTenantsQuery = (
  params = { propertyIds:[], archived:false,maxBalance: null, minBalance:null, daysToLeaseExpiry:0,
  offset:"", searchText: "", limit:50
}) => {
    let {
      propertyIds, archived, maxBalance, minBalance, daysToLeaseExpiry,
      searchText, sortField, sortOrder, offset, limit
    } = params;
    let balanceStr =  (maxBalance != null && maxBalance != "")? `maxBalance: ${maxBalance},`: "";
    balanceStr += (minBalance != null && minBalance != "")? `minBalance: ${minBalance},`: "";
    daysToLeaseExpiry = daysToLeaseExpiry != null? daysToLeaseExpiry : 0;
    const query = `query{
        allTenants(
          propertyIds: ${JSON.stringify(propertyIds)},
          archived: ${JSON.stringify(archived)},
          ${balanceStr}
          daysToLeaseExpiry: ${daysToLeaseExpiry},
          searchText: ${JSON.stringify(searchText)},
          sortField: ${JSON.stringify(sortField)},
          sortOrder: ${JSON.stringify(sortOrder)},
          offset: ${offset === null ? JSON.stringify("") : JSON.stringify(offset)},
          limit: ${JSON.stringify(limit)}
        ) {
          tenants{
            propertyId
            depositJson
            unitName
            unitId
            rentAmount
            tenantId
            firstName
            lastName
            phoneNumber
            email
            accountBalance
            moveInDate
            moveOutDate
            notes
            leaseStartDate
            leaseEndDate
            penaltyType,
            fixedPenaltyAmount,
            percentagePenaltyAmount,
            automaticallyPenalize,
            penaltyDayOfMonth,
            accountId
            taxPin
            nationalIdNumber
            bankPayerNames
            archived
            nextOfKin
            otherPhoneNumbers{
              firstName
              phoneNumber
            }
            nextOfKin
            upload{
              id
              file
            }
          },
          previous,
          next,
          summary{
              header,
              body,
              footer
          }

        }
      }
    `;
    return query;
}

export const ShiftTenantMutation = (tenantId, unitId) => {
  const mutation = `
  mutation{
    shiftTenant(
        tenantId:${JSON.stringify(tenantId)},
        unitId:${JSON.stringify(unitId)}
    ){
      success
      errorMessage
      tenant{
        propertyId
        depositJson
        unitName
        unitId
        rentAmount
        tenantId
        firstName
        lastName
        phoneNumber
        email
        accountBalance
        moveInDate
        moveOutDate
        notes
        leaseStartDate
        leaseEndDate
        penaltyType,
        fixedPenaltyAmount,
        percentagePenaltyAmount,
        automaticallyPenalize,
        penaltyDayOfMonth,
        accountId
        archived
        taxPin
        bankPayerNames
        nationalIdNumber
        nextOfKin
        otherPhoneNumbers{
          firstName
          phoneNumber
        }
        upload{
          id
          file
        }
      }
    }
  }
  `
  return mutation
}